import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { AppState } from '@app/store';
import { sendRouteChange } from '@app/services/api.service';
import {} from './actions';
import { isRootElement, getRootTitle } from '@app/helpers/utils';

export const sendRouteEvent =
  (elementId: number): ThunkAction<void, AppState, null, Action<string>> =>
  async (dispatch, getState) => {
    let title = '';
    let levels = 0;
    let levelsTitle = '';
    let element = getState().catalogue.categories[elementId];
    while (element && element.parentId) {
      levels++;
      levelsTitle = `${element.title}${levels > 1 ? ` -> ${levelsTitle}` : ''}`;
      element = getState().catalogue.categories[element.parentId];
    }
    if (isRootElement(elementId)) {
      title = getRootTitle(elementId);
    } else if (levels < 2) {
      title = getState().catalogue.categories[elementId].title;
    } else {
      title = levelsTitle;
    }

    sendRouteChange({
      url: getState().stats.currentRouteUrl,
      title,
      referer: getState().stats.prevRouteUrl,
    });
  };
